
import React, { Component}  from 'react';
import { DetailProvider, DetailContext } from 'core/DetailProvider';

import Layout  from 'components/Dashboard/Layout';

import { StyledClientDetailOrders } from './Styled';
import {ListContext, ListProvider} from 'core/ListProvider';
import Paper from '@material-ui/core/Paper';
import { OrderTable } from 'components/Order/Table';
import TableListFooter from 'core/TableListFooter';
import TableContainer from '@material-ui/core/TableContainer';
import ClientDetailHeader from "./DetailHeader";
import ListFilterDrawer from "core/ListFilterDrawer";
import OrderListTableFilter from "../Order/ListTableFilter";
import { ResponsiveTable } from 'ui/Table';


export default class ClientDetailOrders extends Component {

  onEdit = () => {
    const { match } = this.props;
    this.props.history.push(`/client/${match.params.id}/edit`);
  };

  render() {
    const { match, history } = this.props;
    return (
      <DetailProvider
        url={`client/${match.params.id}`}
      >
        <DetailContext.Consumer>
          {context => {
            let { item } = context;

            return (
              <Layout>
                <StyledClientDetailOrders>
                  <div>
                    <ClientDetailHeader item={item} history={history} match={match} />

                    <Layout.ContentSimple>
                      <ListProvider
                        url={'order'}
                        storageKey={`ListProvider-order-${item.id}`}
                        filterDefaults={{
                          client: item.id,
                          page_size: 20
                        }}
                      >
                       <ListContext.Consumer>
                         {context => {
                           const { items, loading } = context;

                           return (
                             <>
                              <ListFilterDrawer loading={loading} buttonGroupProps={{className: 'mb-20'}} context={context}>
                                <OrderListTableFilter client={item} />
                              </ListFilterDrawer>
                               <TableContainer component={Paper}>
                                <ResponsiveTable>
                                  <OrderTable
                                    items={items}
                                    onDetail={() => console.log()}
                                  />
                                  <TableListFooter showPerPageSelector={false} colspan={8} />
                                </ResponsiveTable>
                              </TableContainer>
                            </>
                           )
                         }}
                       </ListContext.Consumer>
                      </ListProvider>
                    </Layout.ContentSimple>
                  </div>
                </StyledClientDetailOrders>
              </Layout>
            )
          }}
        </DetailContext.Consumer>
      </DetailProvider>
    )
  }
}
